import { render, staticRenderFns } from "./BaseSignPage.vue?vue&type=template&id=3b232b5c&scoped=true&"
import script from "./BaseSignPage.vue?vue&type=script&lang=js&"
export * from "./BaseSignPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseSignPage.vue?vue&type=style&index=0&id=3b232b5c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b232b5c",
  null
  
)

export default component.exports